import { FlexLayout } from '@deity/falcon-ui';
import type { FC } from 'react';

export const EntityTableDivider: FC = () => (
  <FlexLayout width="full" justifyContent="center" height="full">
    <div style={{ margin: '-14px 8px', width: '1px', background: 'rgba(0, 0, 0, 0.1)' }} />
  </FlexLayout>
);
